module.exports = __webpack_public_path__ + "static/media/plug.328dede9.svg";